export default "/048cb1f2b29308e18768c65cfd51e426596a830c/48d0057cf54c678c61fc778c0aeda84f.svg";